import React, {createContext, useContext, useReducer, Dispatch} from "react";

type UIState = {
  menuOpen: boolean;
  adminOpen: boolean;
  languageOpen: boolean;
  aboutOpen: boolean;
  referenceOpen: boolean;
  productOpen: boolean;
  expertiseOpen: boolean;
};
type UIAction =
  | { type: "toggle"; key: keyof UIState }
  | { type: "set"; key: keyof UIState; value: boolean }
  | { type: "closeAll" };

const initial: UIState = { menuOpen:false, adminOpen:false, languageOpen:false, aboutOpen:false, referenceOpen:false, productOpen:false, expertiseOpen:false };

function reducer(state: UIState, action: UIAction): UIState {
  switch (action.type) {
    case "toggle":
      return { ...state, [action.key]: !state[action.key] };
    case "set":
      return { ...state, [action.key]: action.value };
    case "closeAll":
      return initial;
    default:
      return state;
  }
}

const NavUIContext = createContext<{state:UIState; dispatch:Dispatch<UIAction>} | null>(null);

export const NavUIProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [state, dispatch] = useReducer(reducer, initial);
  return <NavUIContext.Provider value={{state, dispatch}}>{children}</NavUIContext.Provider>;
};

export const useNavUI = () => {
  const ctx = useContext(NavUIContext);
  if (!ctx) throw new Error("useNavUI must be used within NavUIProvider");
  return ctx;
};
